module.exports = __webpack_public_path__ + "static/NimbusSanL-Regu-a257757b015e619e87c97e5200992410.woff";